/**
 * Created by m.igrachev on 7/20/2017.
 */
import getLocale from "./getLocale";

export default function guessDecimalSeparator(locale) {
    let defaultedLocale = getLocale(locale);
    if (!defaultedLocale) return null; //We want to know if defaultedLocale fails
    let testNumber = 1.1;
    let localized = testNumber.toLocaleString(defaultedLocale);
    return localized[1];
}
